import React from "react"

import classes from "./KioskFoodDescription.module.scss"

const KioskFoodDescription = props => {
  const { foodDescription } = props

  return (
    <p className={classes["description"]}>
      {foodDescription}
    </p>
  )
}

export default KioskFoodDescription